import { render, staticRenderFns } from "./myInvitation.vue?vue&type=template&id=6bed3d27&scoped=true&"
import script from "./myInvitation.vue?vue&type=script&lang=js&"
export * from "./myInvitation.vue?vue&type=script&lang=js&"
import style0 from "./myInvitation.vue?vue&type=style&index=0&id=6bed3d27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed3d27",
  null
  
)

export default component.exports